import * as Rx from 'rxjs';

/**
 * The original implementation of this class can be found here:
 * https://github.com/huan/rx-queue/blob/main/src/rx-queue.ts
 */
export class QueueSubject<T = unknown> extends Rx.Subject<T> {
  private itemList: readonly T[] = [];

  addFirst(item: T): void {
    this.itemList = [item, ...this.itemList];
  }

  next(item: T): void {
    if (this.observed) {
      super.next(item);
    } else {
      this.itemList = [...this.itemList, item];
    }
  }

  subscribe(observer: Rx.PartialObserver<T>): Rx.Subscription;
  subscribe(
    next: (value: T) => void,
    error?: (error: any) => void,
    complete?: () => void,
  ): Rx.Subscription;
  subscribe(...args: never[]): never;
  subscribe(
    nextOrObserver: ((value: T) => void) | Rx.PartialObserver<T>,
    error?: (error: any) => void,
    complete?: () => void,
  ): Rx.Subscription {
    let subscription: Rx.Subscription; // TypeScript strict require strong typing differenciation
    if (typeof nextOrObserver === 'function') {
      subscription = super.subscribe({ next: nextOrObserver, error, complete });
    } else {
      subscription = super.subscribe(nextOrObserver);
    }
    this.itemList.forEach(item => this.next(item));
    this.itemList = [];
    return subscription;
  }
}
